module.exports = fox._r("images/press/tsm-img-3.png", __webpack_public_path__ + "_/common/images/press/tsm-img-3.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/tsm-img-3.png
// module id = 414
// module chunks = 2